var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0H3C1.375 0 0 1.11111 0 2.44443V13.5555C0 14.8888 1.25 15.8888 3 15.9999H17C18.625 15.9999 20 14.8888 20 13.5555V2.44443C20 1.11111 18.625 0 17 0ZM17.125 4.11109L10.75 7.66663C10.625 7.77774 10.375 7.77774 10.125 7.77774C9.875 7.77774 9.75 7.77774 9.5 7.66663L3 4.11109C2.5 3.77776 2.25 3.22221 2.625 2.77776C2.875 2.33332 3.625 2.1111 4.125 2.44443L10.125 5.77775L15.875 2.44443C16.375 2.22221 17 2.33332 17.375 2.77776C17.75 3.22221 17.5 3.77776 17.125 4.11109Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSupport);
export default __webpack_public_path__ + "static/media/email_support.f20cad8768e8824e5f7f7a8264186b05.svg";
export { ForwardRef as ReactComponent };